module.exports = __webpack_public_path__ + "img/transparent.be9532fa.png";